import {
  ModeOfTransportationModelODataResultCollection,
  Configuration,
  ModeOfTransportationApi,
} from "api";

import {
  apiResponseTransformer,
  baseApiConfig,
  TransformedApiResponse,
} from "./apiHelpers";

class ModeOfTransportationService {
  private api!: ModeOfTransportationApi;

  constructor(config: Configuration = baseApiConfig) {
    this.api = new ModeOfTransportationApi(config);
  }

  listModesOfTransportation(): Promise<
    TransformedApiResponse<
      ModeOfTransportationModelODataResultCollection,
      ModeOfTransportation[]
    >
  > {
    return this.api
      .apiModeOfTransportationGet()
      .then((result) =>
        apiResponseTransformer<ModeOfTransportationModelODataResultCollection>(
          result
        )
      )
      .then((data) => {
        if (!data) {
          throw new Error("Modes of transportation not found");
        }
        return {
          ...data,
          value:
            data.value?.map((mode) => ({
              code: mode.Code ?? undefined,
              name: mode.Name ?? undefined,
            })) ?? [],
        };
      });
  }
}

export default ModeOfTransportationService;
